export default "__VITE_ASSET__pVHAfu5O__"